import React, { useEffect, useState } from "react"
import API from "../../api/axios"
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import { toast } from "react-toastify"
import { RiUserAddLine } from "react-icons/ri"

const ServiceForm = ({ refresh }) => {
  const [name, setName] = useState("")
  const [price, setPrice] = useState("")
  const [durationId, setDurationId] = useState("")
  const [durations, setDurations] = useState([])
  const [error, setError] = useState("")

  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => {
    if (!modalOpen) {
      setName("")
      setPrice("")
      setDurationId("")
      setError("")
    }
    setModalOpen(!modalOpen)
  }

  useEffect(() => {
    if (modalOpen) fetchDurations()
  }, [modalOpen])

  const fetchDurations = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.get("/duration", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      setDurations(response.data)
    } catch (err) {
      console.error("Error fetching durations:", err)
      // toast.error("Failed to load durations.")
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!name || !price || !durationId) {
      setError("All fields are required.")
      return
    }

    if (!/^[a-zA-Z0-9\s()._-]{3,}$/.test(name)) {
      setError(
        "Service name should be at least 3 characters and may include letters,parentheses(),dot(.),or underscore(_)",
      )
      return
    }

    const authToken = localStorage.getItem("authToken")

    try {
      await API.post(
        "/services",
        {
          name,
          price: parseFloat(price),
          durationId: parseInt(durationId),
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      toast.success("Service added successfully!", { autoClose: 2000 })
      setName("")
      setPrice("")
      setDurationId("")
      setError("")
      toggleModal()
      if (refresh) refresh()
    } catch (err) {
      console.error("Error adding service:", err)
      setError(
        err.response?.data?.message ||
          "Failed to add service. Please try again.",
      )
    }
  }

  return (
    <div>
      <Button color="primary" onClick={toggleModal} className="mb-4 mt-2">
        <RiUserAddLine size={18} className="mr-1" />
        Add Service
      </Button>

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Service</ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label for="serviceName">Name</Label>
              <Input
                type="text"
                id="serviceName"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="Service name"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label for="servicePrice">Price</Label>
              <Input
                type="number"
                id="servicePrice"
                value={price}
                onChange={e => setPrice(e.target.value)}
                placeholder="Enter price"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label for="serviceDuration">Duration</Label>
              <Input
                type="select"
                id="serviceDuration"
                value={durationId}
                onChange={e => setDurationId(e.target.value)}
                required
              >
                <option value="">Select Duration</option>
                {durations.map(dur => (
                  <option key={dur.id} value={dur.id}>
                    {dur.value} minutes
                  </option>
                ))}
              </Input>
            </FormGroup>

            {error && <p className="text-danger">{error}</p>}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              Submit
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  )
}

export default ServiceForm
